import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '@core/models/api-response.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Dropdown } from '@core/models/dropdown.model';

@Injectable()
export class LanguageHttpService {

  constructor(private http: HttpClient) { }

  getLanguage(): Observable<Dropdown[]> {
    return this.http.get<ApiResponse>('/language').pipe(
      map(res => res.data.rows)
    );
  }
}
